import React from 'react'
import { useTranslation } from 'react-i18next'
import { Whisper, Tooltip } from 'rsuite'

const ProductIntendedMaterials = ({ intendedMaterials, productMaterials, productConditionalMaterials = [0] }) => {

  const  { i18n } = useTranslation()
  const lang = i18n.language

  const tooltip = (content) => {
    return (
      <Tooltip>{content}</Tooltip>
    )
  }

  return (    
    <div className="materials">
      {intendedMaterials.map(material => (
        <Whisper placement="top" trigger="hover" speaker={tooltip(material.acf.names[`name_${lang}`])} key={material.id}>
          {productConditionalMaterials.length > 0 ? (
            <div className={`material-single ${productMaterials.includes(material.id) ? productConditionalMaterials.includes(material.id) ? 'conditional active' : 'active' : 'inactive' }`}><img src={material.acf.icon} alt={material.acf.names[`name_${lang}`]} /></div>
          ) : (
            <div className={`material-single ${productMaterials.includes(material.id) ? 'active' : 'inactive' }`}><img src={material.acf.icon} alt={material.acf.names[`name_${lang}`]} /></div>
          )}
        </Whisper>
      ))}
    </div>
  )
}

export default ProductIntendedMaterials